// extracted by mini-css-extract-plugin
module.exports = {"groups":"payment-card-pay-groups_groups__CGM9P"};